import { camelCase, isString } from 'lodash'

export default function fieldNameFromTitle(title) {
  if (!isString(title)) throw new Error('Invalid title type. Must be a string')

  return camelCase(title)
}
